import { Component, type ReactNode } from 'react';
import { useT } from '../i18n/i18n';
import { Banner, Button } from '../ui/components';
import { resetNav } from './navigation';

// TestFlight 211 on the Owner's phone (2026-10-28): one screen threw while rendering (New Inspection step 4, an
// old draft) and, with nothing to catch it, React removed the whole app — a blank page with no way back but
// killing the app. A screen that throws now shows this note with the way home instead; the tab bar and
// everything around the screen stay. Navigating anywhere else (a new resetKey) shows that screen again — the
// boundary itself never remounts a working screen.
export class ScreenErrorBoundary extends Component<{ resetKey: string; children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }

  componentDidCatch(error: unknown): void {
    console.error('[screen] render failed', error);
  }

  componentDidUpdate(previous: { resetKey: string }): void {
    if (this.state.failed && previous.resetKey !== this.props.resetKey) this.setState({ failed: false });
  }

  render(): ReactNode {
    return this.state.failed ? <ScreenFailed /> : this.props.children;
  }
}

function ScreenFailed() {
  const { t } = useT();
  return (
    <div className="screen" data-testid="screen-failed">
      <div className="screen-body">
        <div className="banner-slot">
          <Banner
            tone="warning"
            icon="warning"
            title={t('shell.screenFailedTitle')}
            body={t('shell.screenFailedBody')}
            action={
              <Button variant="secondary" size="small" block={false} icon="home" onClick={() => resetNav({ screen: 'home' })} testId="screen-failed-home">
                {t('shell.screenFailedHome')}
              </Button>
            }
            testId="screen-failed-banner"
          />
        </div>
      </div>
    </div>
  );
}
